/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { networkIngressCreateIngress } from "../funcs/networkIngressCreateIngress.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { NetworkIngress } from "../models/components/networkingress.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateNetworkIngressRequest,
  CreateNetworkIngressSecurity,
} from "../models/operations/createnetworkingress.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateNetworkIngressMutationVariables = {
  request: CreateNetworkIngressRequest;
  security?: CreateNetworkIngressSecurity | undefined;
  options?: RequestOptions;
};

export type CreateNetworkIngressMutationData = NetworkIngress;

export type CreateNetworkIngressMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createIngress networkIngress
 *
 * @remarks
 * Create the organization's Tailscale ingress. Provider credentials are encrypted and never returned.
 */
export function useCreateNetworkIngressMutation(
  options?: MutationHookOptions<
    CreateNetworkIngressMutationData,
    CreateNetworkIngressMutationError,
    CreateNetworkIngressMutationVariables
  >,
): UseMutationResult<
  CreateNetworkIngressMutationData,
  CreateNetworkIngressMutationError,
  CreateNetworkIngressMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateNetworkIngressMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateNetworkIngress(): MutationKey {
  return ["@gram/client", "networkIngress", "createIngress"];
}

export function buildCreateNetworkIngressMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateNetworkIngressMutationVariables,
  ) => Promise<CreateNetworkIngressMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateNetworkIngress(),
    mutationFn: function createNetworkIngressMutationFn({
      request,
      security,
      options,
    }): Promise<CreateNetworkIngressMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(networkIngressCreateIngress(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
